import { render, staticRenderFns } from "./IncomePredictOld.vue?vue&type=template&id=762ef3ae&scoped=true"
import script from "./IncomePredictOld.vue?vue&type=script&lang=js"
export * from "./IncomePredictOld.vue?vue&type=script&lang=js"
import style0 from "./IncomePredictOld.vue?vue&type=style&index=0&id=762ef3ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762ef3ae",
  null
  
)

export default component.exports